import React from "react";
import HubShell from "../../Components/Common/HubShell";
import ServicesPanel from "./ServicesPanel";
import { InternalEndpointsPanel, DatabasePanel } from "./ChecksPanels";
import DataIngestionPanel from "./DataIngestionPanel";
import PrDisciplinePanel from "./PrDisciplinePanel";
import AppErrors from "../AppErrors";

document.title = "Operations | BiorGov Admin";

// "Operations" hub — system/infra health panels + App Errors. (Alerts moved to
// Growth, Notifications moved to Voice — those are user-facing, not infra.)
// Each tab is permission-gated; the route is ungated and HubShell shows only
// the tabs the user is allowed (Forbidden if none).
const TABS = [
  { id: "services",  label: "Services",           icon: "ri-pulse-line",         perm: "service_health.view", render: () => <ServicesPanel /> },
  { id: "database",  label: "Database",           icon: "ri-database-2-line",    perm: "service_health.view", render: () => <DatabasePanel /> },
  { id: "internal",  label: "Internal endpoints", icon: "ri-router-line",        perm: "service_health.view", render: () => <InternalEndpointsPanel /> },
  { id: "ingestion", label: "Data ingestion",     icon: "ri-heart-pulse-line",   perm: "service_health.view", render: () => <DataIngestionPanel /> },
  { id: "pr",        label: "PR discipline",      icon: "ri-git-pull-request-line", perm: "pr_discipline.view", render: () => <PrDisciplinePanel /> },
  { id: "errors",    label: "App Errors",         icon: "ri-error-warning-line", perm: "errors.view",         render: () => <AppErrors embedded /> },
];

const SystemHealth = () => <HubShell title="Operations" pageTitle="System" tabs={TABS} />;

export default SystemHealth;
